var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"id":"sd-bars"}},[_c('path',{attrs:{"id":"top","d":"M0 0h128v16H0z"}}),_c('path',{attrs:{"id":"middle","d":"M0 32h128v16H0z"}}),_c('path',{attrs:{"id":"bottom","d":"M0 64h128v16H0z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }